import React, { useState, useRef } from "react";
import { Modal, Button, Dropdown } from "react-bootstrap";
import "./companySettingsModals.scss";
import CrossIcon from "../../../icons/cross.icon";
import { GreyLoader } from "../../../Theme/APILoaders";
import AddEditTaxRateModal from "../../../Common/AddEditTaxRateModal";
import useUpdateTaxRate from "../../../Common/update-tax-rate.data";

const UpdateAreas = {
  None: 0,
  Default: 1,
  Active: 2,
  Duplicate: 3,
};

const Section = ({ title, list, showMakeDefault, refresh }) => {
  const [taxRateData, setTaxRateData] = useState({});
  const [showAddEditTaxRateModal, setShowAddEditTaxRateModal] = useState(false);
  const [updatingArea, setUpdatingArea] = useState(UpdateAreas.None);
  const { isLoading: isTaxRateUpdating, updateTaxRate } = useUpdateTaxRate();

  return (
    <div className="d-flex flex-column tax-status-section" style={{ gap: '4px' }}>
      <h3 className="m-0 title f-darkgrey">{title}</h3>
      {list.map((item, index) => (
        <div key={index} className="d-flex justify-content-between align-items-center item">
          <div className="d-flex align-items-center f-grey">
            {`${item?.TaxName}${item?.ObjectId > 0 ? ` - ${item.TaxRate}%` : ""}`}
          </div>
          <div className="d-flex align-items-center" style={{ gap: '6px' }}>
            {item?.IsDefault && (
              <span className="f-darkgrey">Default</span>
            )}
            <Dropdown
              alignRight
              className="transparennt-wrapper-dropdown my-dropdown"
              onToggle={(e) => {}}
            >
              <Dropdown.Toggle className="w-100 f-12 f-500 f-grey">
                <div className="d-flex align-items-center p-2">
                  <img
                    alt=""
                    src="/images/settings-v2/horizontal-dots.svg"
                    className=""
                  />
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu 
                className="menu disable-transform align-right"
                alignRight
                renderOnMount
              >
                <div className="m-2 pointer">
                  <div
                    className="mb-2 f-grey"
                    onClick={(e) => {
                      e.stopPropagation();
                      setTaxRateData(item);
                      setShowAddEditTaxRateModal(true);
                      e.target
                        .closest(".transparennt-wrapper-dropdown")
                        .click();
                    }}
                  >
                    Edit
                  </div>
                  <div
                    className="mb-2 f-grey d-flex align-items-center justify-content-between"
                    onClick={(e) => {
                      e.stopPropagation();
                      setTaxRateData(item);
                      setUpdatingArea(UpdateAreas.Duplicate);
                      updateTaxRate({
                        ...item,
                        ObjectId: 0,
                      })
                        .then(() => {
                          refresh();
                          setUpdatingArea(UpdateAreas.None);
                          e.target
                            .closest(".transparennt-wrapper-dropdown")
                            .click();
                        })
                    }}
                  >
                    <span>
                      Duplicate
                    </span>
                    {(isTaxRateUpdating && updatingArea === UpdateAreas.Duplicate) && (
                      <GreyLoader width={13} />
                    )}
                  </div>
                  {(showMakeDefault && !item?.IsDefault && item.ObjectId > 0) && (
                    <div
                      className="mb-2 f-grey d-flex align-items-center justify-content-between"
                      onClick={(e) => {
                        e.stopPropagation();
                        setUpdatingArea(UpdateAreas.Default);
                        updateTaxRate({
                          ...item,
                          IsDefault: true,
                        })
                          .then(() => {
                            refresh();
                            setUpdatingArea(UpdateAreas.None);
                            e.target
                              .closest(".transparennt-wrapper-dropdown")
                              .click();
                          })
                      }}
                    >
                      <span>
                        Make default
                      </span>
                      {(isTaxRateUpdating && updatingArea === UpdateAreas.Default) && (
                        <GreyLoader width={13} />
                      )}
                    </div>
                  )}
                  {item.ObjectId > 0 && (
                    <div
                      className="f-grey d-flex align-items-center justify-content-between"
                      onClick={(e) => {
                        setUpdatingArea(UpdateAreas.Active);
                        updateTaxRate({
                          ...item,
                          IsDisabled: !item.IsDisabled,
                        })
                          .then(() => {
                            refresh();
                            setUpdatingArea(UpdateAreas.None);
                            e.target
                              .closest(".transparennt-wrapper-dropdown")
                              .click();
                          })
                      }}
                    >
                      <span>
                        {item.IsDisabled ? "Enable" : "Disable"}
                      </span>
                      {(isTaxRateUpdating && updatingArea === UpdateAreas.Active) && (
                        <GreyLoader width={13} />
                      )}
                    </div>
                  )}
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      ))}
      {showAddEditTaxRateModal && (
        <AddEditTaxRateModal
          show={showAddEditTaxRateModal}
          hideModal={() => {
            setShowAddEditTaxRateModal(false);
          }}
          taxRateData={taxRateData}
          showDelete={false}
          updateTaxList={() => {
            setShowAddEditTaxRateModal(false);
            return refresh();
          }}
        />
      )}
    </div>
  );
}

const TaxesModal = ({ show, hideModal, taxRates, refresh }) => {
  const [saving, setSaving] = useState(false);

  const activeTaxes = taxRates?.filter(item => !item?.IsDisabled);
  const disabledTaxes = taxRates?.filter(item => item?.IsDisabled);

  const modalBodyRef = useRef(null);

  return (
    <Modal
      animation={false}
      show={show}
      dialogClassName=" company-settings-notifications-modal taxes-modal"
      className={`hide-scrollbar`}
      aria-labelledby=" company-settings-notifications-modal"
      centered
      scrollable
      onHide={() => {
        hideModal();
      }}
    >
      <Modal.Header className="text-center border-bottom d-flex align-items-center" style={{ padding: '12px' }}>
        <div className="w-100 mb-0 font-bold-14 f-500 ml-2">
          Taxes
        </div>

        <span 
          className="cursor-pointer" 
          onClick={() => {
            hideModal();
          }}
          style={{ padding: '4px 10px' }}
        >
          <CrossIcon width="12px" height="12px" fill="#616778" style={{ minWidth: "10px", minHeight: "10px" }} />
        </span>
      </Modal.Header>
      <Modal.Body ref={modalBodyRef} className="p-0 hide-scrollbar modal-body">
        <div className="h-100 d-flex flex-column" style={{ padding: '24px', gap: '16px' }}>
          <Section title="Active" list={activeTaxes} showMakeDefault refresh={refresh} />
          <Section title="Disabled" list={disabledTaxes} refresh={refresh} />
        </div>
      </Modal.Body>

      <Modal.Footer className="d-flex border-top">
        <div className="d-flex justify-content-end w-100" style={{ gap: '8px' }}>
          <Button className="hg-cancel-btn" onClick={() => {
            hideModal()
          }}>
            Cancel
          </Button>
          <Button
            className="hg-blue-btn"
            onClick={() => {
              hideModal()
            }}
            // onClick={() => UpdateNotificationOptions()}
          >
            {saving ? "Saving.." : "Save"}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default TaxesModal;
